export default __webpack_public_path__ + "static/media/Document PDF.b8d296a6.svg";